module.exports = __webpack_public_path__ + "files/c0de782c846e2be7f3008be61d14f853.png";